<template>
  <div class="authority-manage position-header">
    <navHeader :titleList="['工厂展商']" />
    <div class="rhBrand-content common-padding">
      <el-card class="box-card">
        <el-row>
          <el-col :span="5">
            <span class="search-text">企业名称：</span>
            <el-input
                class="search-item"
                placeholder="请输入企业名称"
                clearable
                v-model="exhibitionName"
                size="small"
            ></el-input>
          </el-col>
          <el-col :span="8">
            <el-button class="btn-search" round icon="el-icon-search" @click="search" size="small">查询
            </el-button>
            <el-button type="warning" round icon="el-icon-refresh" @click="reset" size="small">重置
            </el-button>
          </el-col>
        </el-row>
      </el-card>
      <el-card class="box-card flex-1 table-card">
        <el-row>
          <el-col :span="12">
            <el-button :disabled="selectData.length === 0" type="danger" icon="el-icon-delete" size="small"
                       @click="deleteMore" v-if="hasPerm('factoryCompanyIndex-batch-delete')">批量删除</el-button>
            <el-button :disabled="exportLoading" type="warning" icon="el-icon-sell" size="small"
                       v-if="hasPerm('factoryCompanyIndex-export')" @click="exportAll">{{ exportLoading ? '正在导出中...' :
                '全部导出'
              }}</el-button>
          </el-col>
        </el-row>
        <el-row class="common-margin flex-1 table-main">
          <el-table
              :data="tableData"
              class="flex-1" stripe height="100%"
              @selection-change="selectRow"
              border
              style="width: 100%"
          >
            <el-table-column type="selection" width="60px" align="center"> </el-table-column>
            <el-table-column prop="exhibitionName" label="展商名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="createTime" label="扫码时间" align="center" show-overflow-tooltip></el-table-column>
          </el-table>
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next, sizes"
              :total="total"
          >
          </el-pagination>
        </el-row>
      </el-card>
    </div>
  </div>
</template>

<script>
import navHeader from '../../components/navHeader.vue'

export default {
  data () {
    return {
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      exhibitionName: '',
      phone: '',
      selectData: [],
      exportLoading: false
    }
  },
  components: {
    navHeader
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 300
    this.getPageList()
  },
  mounted () {},
  methods: {
    async getPageList () {
      let params = {
        pageSize: this.pageSize,
        currentPage: this.currentPage,
        compositeType: '5',
        companyName: this.exhibitionName,
        phone: this.phone
      }
      let { data: res } = await this.$http.post('/qrVisitLogs/getPageList', params)
      if (res.code === '200') {
        this.tableData = res.data.records
        this.total = Number(res.data.total)
      } else {
        this.$message.error(res.msg)
      }
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList()
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList()
    },
    search () {
      this.currentPage = 1
      this.getPageList()
    },
    reset () {
      this.companyName = ''
      this.phone = ''
      this.currentPage = 1
      this.getPageList()
    },
    selectRow (selection) {
      this.selectData = selection
    },
    deleteMore () {
      this.$confirm(`确认删除选中的${this.selectData.length}条数据?`, '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(() => {
        let ids = this.selectData.map(item => item.id)
        ids = ids.join(',')
        this.$http.post('/qrVisitLogs/batchDelete', { ids }).then(res => {
          if (res.data.code === '200') {
            this.$message.success(res.data.msg)
            this.getPageList()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    exportAll () {
      this.$confirm(`确认导出数据?`, '导出提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        closeOnClickModal: false,
        showClose: false
      }).then(async () => {
        this.exportLoading = true
        let params = {
          companyName: this.exhibitionName,
          phone: this.phone,
          compositeType: '5'
        }
        this.$http.post('/qrVisitLogs/exportData', params, { responseType: 'blob' }).then(res => {
          console.log(res)
          const link = document.createElement('a')
          let blob = new Blob([res.data], { type: 'application/x-excel' })
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob)
          link.download = '工厂展商扫码数据.xlsx'
          document.body.appendChild(link)
          link.click()
          window.URL.revokeObjectURL(link.href)
          document.body.removeChild(link)
          this.$message.success('导出成功')
          this.exportLoading = false
        }).catch(() => {
          this.exportLoading = false
          this.$message.success('导出失败')
        })
      }).catch(() => {
        this.$message.info('取消导出')
      })
    }
  }
}
</script>

<style lang="less"></style>



// WEBPACK FOOTER //
// src/pages/codeData/factoryCompanyIndex.vue